import { IDataTypeSerializerFactory, IDataTypeSerializer, DefaultDataTypeSerializerFactory } from '@ecp-caf/common-structure';
import { DtoConstant } from '../../../define/gsp-dto-constant';
import { GspDtoDataTypeSerializer } from '../serializer/gsp-dto-data-type-serializer';
import { ExtendStructureTypeSerializer } from '../serializer/extend-structure-type-serializer';
import { ExtendEnumTypeSerializer } from '../serializer/extend-enum-type-serializer';

export class GspDtoDataTypeSerializerFactory implements IDataTypeSerializerFactory {

    get(kind: string): IDataTypeSerializer {
        switch (kind) {
            case  DtoConstant.DTO_STRUCTURED_TYPE_REF:
                return new GspDtoDataTypeSerializer();
            case  DtoConstant.EXTEND_STRUCTURE_TYPE:
                return new ExtendStructureTypeSerializer();
            case  DtoConstant.EXTEND_ENUM_TYPE:
                return new ExtendEnumTypeSerializer();
            default:
                return new DefaultDataTypeSerializerFactory().get(kind);
        }
    }

}